import { ref } from 'vue';

const serverHasCrashed = ref(false);
const queryStringInvalid = ref(false);

export default function useServerCrash() {
  return {
    serverHasCrashed,
    queryStringInvalid,
  };
}
